import request from 'api/request';

export default function createAccountRoute(data) {
  return request({ url: '/users', method: 'POST', data });
}
